<template>
  <b-table v-bind="tableAttributes" :items="items" :fields="fields">

    <template #cell(id)="data">
      <span class="text-wrap">{{ data.item.id }}</span>
    </template>


    <template #cell(user)="data">
      <span class="text-wrap">{{ data.item.user.name }} {{ data.item.user.last_name }}</span>
    </template>

    <template #cell(offer_amount)="data">
      <span class="text-wrap">{{ formatNumber(data.item.offer_amount) }}</span>
    </template>

    <template #cell(paying_amount)="data">
      <span class="text-wrap">{{ formatNumber(data.item.paying_amount) }}</span>
    </template>

    <template #cell(total_amount)="data">
      <span class="text-wrap">{{ formatNumber(data.item.total_amount) }}</span>
    </template>

    <template #cell(payment_status)="data">
      <span class="text-wrap">{{ data.item.payment_status.status_name }}</span>
    </template>

    <template #cell(status)="data">
      <select v-if="data.item.payment_status.status_id==2 && $store.getters['User/isAdmin']"
              @change="setDataForChangeOrderStatus(data)"
              v-model="data.item.status.status_id" class="form-control">
        <option class="text-dark" v-for="(order_status_item,index) in getOrderStatus" v-if="index >0"
                :value="index">
          {{ order_status_item }}
        </option>
      </select>

      <span v-else>{{ data.item.status.status_name }}</span>

    </template>

    <template #cell(action)="data">

      <div v-if="data.item.payment_status.status_id==2">
        <span class="h5" v-b-tooltip.hover title="جزییات سبد">
          <router-link
              :to="{ name: 'Factor', params: { orderId: data.item.id } }"
          >
            <b-icon icon="basket-fill" class="mr-3"></b-icon>
          </router-link>
        </span>
      </div>

      <div v-else>
        <span class="h5" v-b-tooltip.hover title="جزییات سبد">
          <router-link
              :to="{ name: 'ShoppingCart'}"
          >
            <b-icon icon="basket-fill" class="mr-3"></b-icon>
          </router-link>
        </span>
      </div>

    </template>

    <template #cell(comment)="data">
      <m-comment-create-modal-1 :custom_button="true" :commentable_id="data.item.id" commentable_type="order">
        <template #modal-button>

          <b-button variant="transparent" class=" border-0" v-b-modal="'create-comment-'+data.item.id"
                    v-if="data.item.status.status_id === 4">
            <b-icon class="box bounce-7" icon="chat-square-text-fill"/>
          </b-button>

        </template>
      </m-comment-create-modal-1>
    </template>
  </b-table>
</template>
<script>
import {mapActions} from 'vuex';
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {order_status} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart';
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {VueEditor} from "vue2-editor";
import FormGroup from "../../validator/FormGroup";
import {required} from "vuelidate/lib/validators";
import FormErrorsManager from '../../validator/FormErrorsManager.vue';
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import StarRating from 'vue-star-rating'

export default {
  name: "tableItemOfOrders",
  components: {VueEditor, FormGroup, FormErrorsManager, StarRating},
  props: ["items", "restoreState"],
  data() {
    return {
      tableAttributes,
      fields: [
        {key: "id", label: "شناسه سبد"},
        {key: "user", label: "کاربر"},
        {key: "total_amount", label: "قیمت کل"},
        {key: "offer_amount", label: "تخفیف"},
        {key: "paying_amount", label: "پرداختی"},
        {key: "payment_status", label: "وضعیت پرداخت"},
        {key: "status", label: "وضعیت سبد"},
        {key: "action", label: ""},
        {key: "comment", label: "نظر دادن"}
      ],
      order_status,
      order_id: '',
      commentForm: {
        body: '',
        rate: 1,
        commentable_type: 'order',
        commentable_id: ''
      },
      customToolbar: [
        ["bold", "italic", "underline"],
        [{list: "ordered"}, {list: "bullet"}],
        [
          {align: ""},
          {align: "center"},
          {align: "right"},
          {align: "justify"}
        ],
        [{color: []}]
      ]
    };
  },
  validations: {
    commentForm: {
      body: {required},
      rate: {required}
    },
  },
  computed: {
    getOrderStatus() {
      return this.order_status;
    }
  },
  methods: {
    ...mapActions({
      changeOrderStatus: 'ShoppingCart/changeOrderStatus',
    }),
    setDataForChangeOrderStatus(data) {
      const order_id = data.item.id;
      const status = data.item.status.status_id;
      this.changeOrderStatus({order_id, status});

    },
    formatNumber,
    setOrderId(id) {
      this.order_id = id
      this.commentForm.commentable_id = id
    },
    createComment() {
      if (this.commentForm.rate === 0) {
        this.commentForm.rate = 1
      }
      this.$store.dispatch("Comment/createComment", this.commentForm).then(res => {
        toast('', 'کامنت شما با موفقیت ثبت شد و در انتظار برای تایید قرار گرفت')
      })
    },
    resetCommentForm() {
      this.commentForm = {
        body: '',
        rate: 1,
        commentable_type: 'order',
        commentable_id: ''
      }
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit(bvModalEvent) {
      bvModalEvent.preventDefault()
      if (this.invalid()) {
        this.createComment()
        this.$nextTick(() => {
          this.$bvModal.hide('comment-' + this.order_id)
          this.resetCommentForm()
        })
      }
    },
  },

};
</script>

<style scoped>

.box {
  align-self: flex-end;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  background-color: transparent;
  color: orange;
  margin: 0 auto 0 auto;
  transform-origin: bottom;

}

.bounce-7 {
  animation-name: bounce-7;
  animation-timing-function: cubic-bezier(0.280, 0.840, 0.420, 1);
}

@keyframes bounce-7 {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(1.1, .9) translateY(0);
  }
  30% {
    transform: scale(.9, 1.1) translateY(-17px);
  }
  50% {
    transform: scale(1.05, .95) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(-7px);
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}

.rate-s {
  height: 40px !important;
  width: max-content !important;
}

</style>